/**
 * Muestras en el cart-drawer: el cliente elige en el panel.
 * - Total carrito (cart.total_price) ≥ umbral 1 (ej. 50€): hasta 1 muestra seleccionable.
 * - Total ≥ umbral 2 (ej. 100€): hasta 2 muestras seleccionables.
 * Al bajar de umbral se recorta la selección y se actualiza el carrito.
 */
(function () {
  'use strict';

  function isSamplesSpain() {
    return !!(window.theme && window.theme.isSamplesSpain);
  }

  function refreshCartUI() {
    document.dispatchEvent(new CustomEvent('theme:cart:reload', { bubbles: true }));
  }

  function isSampleLine(item) {
    var p = item && item.properties;
    return p && (p.sample === true || p.sample === 'true');
  }

  function isPerfumeLine(item) {
    if (!item) return false;
    var p = item.properties || {};
    if (String(p._rockin_product_category || '').toLowerCase() === 'perfume') return true;
    if (String(item.product_type || '').toLowerCase() === 'perfume') return true;
    return false;
  }

  function cartHasPerfume(cart) {
    return paidLines(cart).some(isPerfumeLine);
  }

  function linkedSampleTargetsFromCart(cart) {
    var targets = [];
    if (!isSamplesSpain()) return targets;
    (cart.items || []).forEach(function (item) {
      if (isSampleLine(item)) return;
      if (!isPerfumeLine(item)) return;
      var p = item && item.properties ? item.properties : {};
      var rawVid = p && (p._linked_sample_variant_id || p.linked_sample_variant_id);
      if (!rawVid) return;
      var variantId = Number(rawVid);
      if (isNaN(variantId)) return;

      var parentProductId = Number(p._linked_sample_parent_product_id || item.product_id);
      targets.push({
        variantId: variantId,
        parentKey: item.key,
        parentProductId: isNaN(parentProductId) ? '' : String(parentProductId),
      });
    });
    return targets;
  }

  function paidLines(cart) {
    return (cart.items || []).filter(function (i) {
      return !isSampleLine(i);
    });
  }

  function expandedSampleVariantIds(cart) {
    var out = [];
    (cart.items || []).forEach(function (it) {
      if (!isSampleLine(it)) return;
      var q = Math.max(0, parseInt(it.quantity, 10) || 0);
      for (var i = 0; i < q; i++) out.push(it.variant_id);
    });
    return out.sort(function (a, b) {
      return a - b;
    });
  }

  function idsEqualSorted(a, b) {
    if (a.length !== b.length) return false;
    for (var i = 0; i < a.length; i++) {
      if (Number(a[i]) !== Number(b[i])) return false;
    }
    return true;
  }

  /** Cuántas muestras puede elegir el cliente según el total del carrito (céntimos). */
  function maxSamplesAllowed(totalCents, tier1, tier2) {
    if (totalCents < tier1) return 0;
    if (totalCents < tier2) return 1;
    return 2;
  }

  function readStoredIds(storageKey) {
    try {
      var raw = localStorage.getItem(storageKey);
      if (!raw) return [];
      var arr = JSON.parse(raw);
      return Array.isArray(arr) ? arr.map(String) : [];
    } catch (e) {
      return [];
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    var root = document.getElementById('cart-samples-root');
    var panel = document.getElementById('samples-side-panel');
    if (!root || !panel) return;

    var samplesBlock = root.querySelector('.cart-samples-block');
    var drawerTitleEl = root.querySelector('.cart-samples-title');
    var cartPriceElement = document.querySelector('[data-cart-final]');

    var tier1 = parseInt(root.getAttribute('data-tier1-cents') || '5000', 10);
    var tier2 = parseInt(root.getAttribute('data-tier2-cents') || '10000', 10);
    var storageKey = root.getAttribute('data-storage-key') || 'selectedSampleVariantIds';

    var changeBtn = document.getElementById('cart-samples-change');
    var closeBtn = document.getElementById('samples-close');
    var sampleCards = document.querySelectorAll('.sample-card');
    var samplePreviewSlot = document.getElementById('sample-preview-slot');
    var panelTitleEl = panel.querySelector('.samples-panel-heading, h2');
    var headingTemplateFallback = root.getAttribute('data-i18n-panel-heading-template') || '';

    var chooseTitleOne = root.getAttribute('data-i18n-choose-title-one') || '';
    var chooseTitleOther = root.getAttribute('data-i18n-choose-title-other') || '';
    var headingTemplateOne = root.getAttribute('data-i18n-panel-heading-template-one') || '';
    var headingTemplateOther = root.getAttribute('data-i18n-panel-heading-template-other') || '';

    function safeTextTemplate(raw, fallback) {
      var t = String(raw || '').trim();
      if (!t) return fallback;
      if (t.indexOf('translation missing') !== -1) return fallback;
      return t;
    }

    function buildPanelHeadingText(selectedCount, additionalCount, rawTemplate) {
      var fallback = 'Choose your complimentary samples ({selected} selected, you can choose {additional} more)';
      var tpl = safeTextTemplate(rawTemplate, fallback);
      return tpl
        .replace(/\{selected\}/g, String(selectedCount))
        .replace(/\{additional\}/g, String(additionalCount));
    }

    function pickPluralForm(maxSel) {
      return maxSel === 1 ? 'one' : 'other';
    }

    function applyChooseTitle(maxSel) {
      var form = pickPluralForm(maxSel);
      var fallback = 'Choose your complimentary samples';
      var title = form === 'one' ? chooseTitleOne : chooseTitleOther;
      title = safeTextTemplate(title, fallback);
      if (drawerTitleEl) drawerTitleEl.textContent = title;
    }

    var userSelectedVariantIds = new Set();
    var lockedVariantIds = new Set();
    var isSyncing = false;
    var debounceTimer = null;

    function startLoading() {
      isSyncing = true;
      root.classList.add('is-loading');
      panel.classList.add('is-loading');
    }

    function stopLoading() {
      isSyncing = false;
      root.classList.remove('is-loading');
      panel.classList.remove('is-loading');
    }

    function openPanel() {
      panel.setAttribute('aria-hidden', 'false');
      panel.classList.add('opened');
      document.body.classList.add('samples-panel-open');
      updatePanelUI();
    }

    function closePanel() {
      panel.setAttribute('aria-hidden', 'true');
      panel.classList.remove('opened');
      document.body.classList.remove('samples-panel-open');
    }

    /**
     * Máximo de sample-card seleccionables en el panel: solo lo fijan los umbrales (50€ → 1, 100€ → 2).
     * No usar samples_max_select del tema aquí: en tiendas con valor antiguo "1" bloqueaba la 2ª muestra.
     */
    function panelMaxSelect(cart) {
      return maxSamplesAllowed(cart.total_price || 0, tier1, tier2);
    }

    function trimUserSelectionToAllowed(allowed) {
      var arr = Array.from(userSelectedVariantIds);
      if (arr.length <= allowed) return;
      userSelectedVariantIds = new Set(arr.slice(0, allowed));
      updateSelectedSampleUI();
    }

    function totalSelectedCount() {
      return lockedVariantIds.size + userSelectedVariantIds.size;
    }

    function combinedSelectedVariantIds() {
      var combined = new Set();
      lockedVariantIds.forEach(function (id) {
        combined.add(String(id));
      });
      userSelectedVariantIds.forEach(function (id) {
        combined.add(String(id));
      });
      return combined;
    }

    function userMaxSelectable(allowed) {
      // Si hay un sample vinculado y allowed=1, no debe permitir elegir otro sample.
      // Si allowed=2, permite 1 adicional (pero si el usuario ya tiene 2 seleccionados, no se recorta: se permite acumular).
      var lockedSlots = Math.min(lockedVariantIds.size, allowed);
      return Math.max(0, allowed - lockedSlots);
    }

    function updateSelectedSampleUI() {
      var selectedData = [];
      var combined = combinedSelectedVariantIds();
      sampleCards.forEach(function (card) {
        if (combined.has(card.getAttribute('data-variant-id'))) {
          selectedData.push({
            title: card.getAttribute('data-product-title') || '',
            imgSrc: card.getAttribute('data-img') || '',
          });
        }
      });

      if (!samplePreviewSlot) return;

      if (selectedData.length === 0) {
        samplePreviewSlot.innerHTML = '<div class="no-samples"></div>';
        if (userSelectedVariantIds.size === 0) localStorage.removeItem(storageKey);
        return;
      }

      samplePreviewSlot.innerHTML = selectedData
        .map(function (data) {
          return (
            '<div class="selected-sample-item">' +
            '<img src="' +
            data.imgSrc +
            '" alt="' +
            (data.title || '').replace(/"/g, '&quot;') +
            '" style="max-width:50px;height:auto;">' +
            '</div>'
          );
        })
        .join('');

      localStorage.setItem(storageKey, JSON.stringify(Array.from(userSelectedVariantIds)));
    }

    function updatePanelUI() {
      window
        .fetch('/cart.js')
        .then(function (r) {
          return r.json();
        })
        .then(function (cart) {
          var maxSel = panelMaxSelect(cart);
          lockedVariantIds = new Set(
            linkedSampleTargetsFromCart(cart).map(function (t) {
              return String(t.variantId);
            })
          );
          var userMax = userMaxSelectable(maxSel);
          var userCount = userSelectedVariantIds.size;
          var limitReached = userCount >= userMax && userMax > 0;
          var combined = combinedSelectedVariantIds();

          applyChooseTitle(maxSel);

          sampleCards.forEach(function (card) {
            var vid = card.getAttribute('data-variant-id');
            var isLocked = lockedVariantIds.has(vid);
            var isSelected = combined.has(vid);
            card.classList.toggle('is-selected', isSelected);
            card.classList.toggle('is-locked', isLocked);
            card.classList.toggle('is-disabled-by-limit', limitReached && !isSelected);
          });

          if (panelTitleEl) {
            var rawTpl =
              pickPluralForm(maxSel) === 'one' ? headingTemplateOne : headingTemplateOther;
            rawTpl = safeTextTemplate(rawTpl, headingTemplateFallback);
            panelTitleEl.textContent = buildPanelHeadingText(totalSelectedCount(), userMax, rawTpl);
          }
        })
        .catch(function () {});
    }

    function loadSelectedSample() {
      var storedIds = readStoredIds(storageKey);
      if (storedIds.length) {
        userSelectedVariantIds = new Set(storedIds);
        updateSelectedSampleUI();
      }
    }

    function setVisibilityFromCart(cart) {
      if (!samplesBlock) return;
      var total = cart.total_price || 0;
      var paid = paidLines(cart).length;
      if (paid > 0 && total >= tier1) {
        samplesBlock.style.display = 'block';
      } else {
        samplesBlock.style.display = 'none';
      }
    }

    /**
     * Deja el carrito alineado con la selección actual (como mucho `allowed` líneas de muestra).
     */
    async function syncDesiredSamplesToCart(cart) {
      if (isSyncing) return;

      var allowed = maxSamplesAllowed(cart.total_price || 0, tier1, tier2);
      trimUserSelectionToAllowed(allowed);

      if (allowed === 0) {
        var samplesZero = (cart.items || []).filter(isSampleLine);
        if (samplesZero.length === 0) {
          setVisibilityFromCart(cart);
          return;
        }
        lockedVariantIds = new Set();
        startLoading();
        try {
          for (var z = 0; z < samplesZero.length; z++) {
            await window.fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: samplesZero[z].key, quantity: 0 }),
            });
          }
          var u0 = await window.fetch('/cart.js').then(function (r) {
            return r.json();
          });
          document.dispatchEvent(
            new CustomEvent('theme:cart:change', { detail: { cart: u0 }, bubbles: true })
          );
          refreshCartUI();
        } catch (e) {
          console.error('Muestras: error al vaciar muestras', e);
        } finally {
          stopLoading();
        }
        return;
      }

      var linkedTargets = linkedSampleTargetsFromCart(cart);
      lockedVariantIds = new Set(
        linkedTargets.map(function (t) {
          return String(t.variantId);
        })
      );

      var desired = Array.from(userSelectedVariantIds)
        .slice(0, allowed)
        .map(function (id) {
          return Number(id);
        })
        .filter(function (id) {
          return !isNaN(id);
        });

      var targetItems = [];
      for (var lt = 0; lt < linkedTargets.length; lt++) {
        targetItems.push({
          id: linkedTargets[lt].variantId,
          properties: {
            sample: 'true',
            sample_source: 'linked_product',
            sample_parent_key: linkedTargets[lt].parentKey,
            sample_parent_product_id: linkedTargets[lt].parentProductId,
          },
        });
      }
      for (var du = 0; du < desired.length; du++) {
        targetItems.push({
          id: desired[du],
          properties: { sample: 'true' },
        });
      }

      var curSorted = expandedSampleVariantIds(cart);
      var targetSorted = targetItems
        .map(function (x) {
          return x.id;
        })
        .slice()
        .sort(function (a, b) {
          return a - b;
        });

      if (idsEqualSorted(curSorted, targetSorted)) {
        setVisibilityFromCart(cart);
        return;
      }

      startLoading();
      try {
        var fresh = await window.fetch('/cart.js').then(function (r) {
          return r.json();
        });
        var existingSamples = (fresh.items || []).filter(isSampleLine);

        for (var i = 0; i < existingSamples.length; i++) {
          await window.fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: existingSamples[i].key, quantity: 0 }),
          });
        }

        for (var j = 0; j < targetItems.length; j++) {
          await window.fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              id: targetItems[j].id,
              quantity: 1,
              properties: targetItems[j].properties,
            }),
          });
        }

        var updated = await window.fetch('/cart.js').then(function (r) {
          return r.json();
        });
        document.dispatchEvent(
          new CustomEvent('theme:cart:change', { detail: { cart: updated }, bubbles: true })
        );
        refreshCartUI();
        setVisibilityFromCart(updated);
      } catch (err) {
        console.error('Muestras: error al sincronizar', err);
      } finally {
        stopLoading();
      }
    }

    function scheduleEnforce(cart) {
      if (debounceTimer) clearTimeout(debounceTimer);
      debounceTimer = setTimeout(function () {
        debounceTimer = null;
        if (cart) {
          setVisibilityFromCart(cart);
          trimUserSelectionToAllowed(maxSamplesAllowed(cart.total_price || 0, tier1, tier2));
          syncDesiredSamplesToCart(cart);
        } else {
          window
            .fetch('/cart.js')
            .then(function (r) {
              return r.json();
            })
            .then(function (c) {
              setVisibilityFromCart(c);
              trimUserSelectionToAllowed(maxSamplesAllowed(c.total_price || 0, tier1, tier2));
              return syncDesiredSamplesToCart(c);
            })
            .catch(function () {});
        }
      }, 280);
    }

    document.addEventListener('theme:cart:change', function (event) {
      var cart = event.detail && event.detail.cart;
      if (!cart) return;
      scheduleEnforce(cart);
    });

    if (cartPriceElement) {
      var observer = new MutationObserver(function () {
        scheduleEnforce(null);
      });
      observer.observe(cartPriceElement, { characterData: true, subtree: true, childList: true });
    }

    loadSelectedSample();

    window
      .fetch('/cart.js')
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        setVisibilityFromCart(cart);
        trimUserSelectionToAllowed(maxSamplesAllowed(cart.total_price || 0, tier1, tier2));
        syncDesiredSamplesToCart(cart);
      })
      .catch(function () {});

    changeBtn &&
      changeBtn.addEventListener('click', function (e) {
        e.preventDefault();
        window
          .fetch('/cart.js')
          .then(function (r) {
            return r.json();
          })
          .then(function (cart) {
            setVisibilityFromCart(cart);
            if (samplesBlock && samplesBlock.style.display === 'block') {
              updatePanelUI();
              openPanel();
            }
          })
          .catch(function () {});
      });

    closeBtn &&
      closeBtn.addEventListener('click', function (e) {
        e.preventDefault();
        closePanel();
      });

    panel.addEventListener('click', function (e) {
      if (e.target === panel) closePanel();
    });

    sampleCards.forEach(function (card) {
      card.addEventListener('click', function () {
        if (isSyncing) return;

        window
          .fetch('/cart.js')
          .then(function (r) {
            return r.json();
          })
          .then(async function (cart) {
            var maxSel = panelMaxSelect(cart);
            lockedVariantIds = new Set(
              linkedSampleTargetsFromCart(cart).map(function (t) {
                return String(t.variantId);
              })
            );
            var userMax = userMaxSelectable(maxSel);
            var vid = card.getAttribute('data-variant-id');
            var isLocked = lockedVariantIds.has(vid);
            if (isLocked) return;
            var isSelected = userSelectedVariantIds.has(vid);

            if (isSelected) {
              userSelectedVariantIds.delete(vid);
              card.classList.remove('is-selected');
            } else {
              if (userSelectedVariantIds.size >= userMax) {
                card.classList.add('limit-reached');
                setTimeout(function () {
                  card.classList.remove('limit-reached');
                }, 600);
                return;
              }
              userSelectedVariantIds.add(vid);
              card.classList.add('is-selected');
            }

            updateSelectedSampleUI();
            updatePanelUI();
            await syncDesiredSamplesToCart(cart);

            var cartAfter = await window.fetch('/cart.js').then(function (r) {
              return r.json();
            });
            var ms = panelMaxSelect(cartAfter);
            var uMax = userMaxSelectable(ms);
            if (uMax > 0 && userSelectedVariantIds.size === uMax) {
              closePanel();
            }
          })
          .catch(function () {});
      });
    });
  });
})();
